// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nvideo[data-v-65b23898] {\n  width: 100%;\n  height: 95%;\n}\n.v-image__image[data-v-65b23898] {\n  background-size: 100% 100%;\n}\n", ""]);
// Exports
module.exports = exports;
